import React from 'react'
import '../assests/working.css'
function Working() {
  return (
    <div>
        <div className="work-heading">
          <h1>
            How
            {" "}
            <span style={{color:'#32BAC7'}}>SGC</span>
            {" "}
            works ?
          </h1>
        </div>
        <div className="work-definition">
            Professional counselors (to be appointed) in the campus will be available for counseling purposes at any time     of need as per the student.
            <br></br>
            <div style={{height:"20px",width:"100%"}}></div>
            Student-faculty meetings will be organized to improve the relationship between them.
            <br></br>
            <div style={{height:"20px",width:"100%"}}></div>
            Students and parents should keep in touch with their respective faculty advisors continuously.
        </div>
    </div>
  )
}

export default Working